import SimpleMarkerSymbol from '@arcgis/core/symbols/SimpleMarkerSymbol';
// import PictureMarkerSymbol from '@arcgis/core/symbols/PictureMarkerSymbol';
import SimpleLineSymbol from '@arcgis/core/symbols/SimpleLineSymbol';
import SimpleFillSymbol from '@arcgis/core/symbols/SimpleFillSymbol';
import TextSymbol from '@arcgis/core/symbols/TextSymbol';
import DrainIcon from '../assets/images/drain.svg';
import BlockIcon from '../assets/images/block.svg';

// Color Definitions
export const __wwLevelColor: string = "rgba(7, 140, 234, 0.5)";
export const __wwLevelOutColor: string = "#888888"; // "#666666";
export const __wwOffMagentaColor: string = "#FF01DF";
export const __wwConnectedLineColor: string = "#1817C8";
export const __wwCrossPolygonColor: string = "rgba(252, 117, 48, 0.57)";
export const __wwCrossPolygonOutColor: string = "#FC7530";
export const __wwFlowArrowLineColor: string = "#1817C8";
export const __wwSeedingPolygonColor: string = "#12DA04";
export const __wwBreaklinesSymbolColor: string = "#CD2026";
export const __trcRidgeTopFillColor: string = "#B28862";
export const __trcSlopeFillColor: string = "rgba(178, 136, 98, 0.5)";
export const __trcRidgeTopBorderColor: string = "#534741";
export const __trcSlopeBorderColor: string = "rgba(83, 71, 65, 0.5)";
export const __trcChannelBottomColor: string = "#F15A24";
export const __hiddenLineSymbol = new SimpleLineSymbol({
  style: 'solid',
  color: 'transparent',
});

const __svgSymbolSize = 20;

export const __drainStationMarkerSymbol = {
  type: "picture-marker" as const,
  url: DrainIcon,
  width: __svgSymbolSize,
  height: __svgSymbolSize,
  xoffset: 0,
  yoffset: 0
};

export const __blockStationMarkerSymbol = {
  type: "picture-marker" as const,
  url: BlockIcon,
  width: __svgSymbolSize,
  height: __svgSymbolSize,
  xoffset: 0,
  yoffset: 0
};

export const __centerPointSymbol = new SimpleMarkerSymbol({
  color: [0, 255, 0],
  size: 6,
  style: 'circle',
  outline: {
    style: 'solid',
    color: [0, 0, 0],
    width: 1,
  },
});

export const __slopeArrowLineSymbol = new SimpleLineSymbol({
  color: [255, 159, 0], //gold
  width: 2,
  marker: {
    color: [255, 159, 0],
    placement: 'end',
    style: 'arrow',
  },
});

export const __wwSlopeArrowLineSymbol = new SimpleLineSymbol({
  color: [255, 159, 0], //gold
  width: 3,
  marker: {
    color: [255, 159, 0],
    placement: 'end',
    style: 'arrow',
  },
});

export const __wwFlowArrowLineSymbol = new SimpleLineSymbol({
  color: __wwFlowArrowLineColor,
  width: 3,
  marker: {
    color: __wwFlowArrowLineColor,
    placement: 'end',
    style: 'arrow',
  },
});

export const __landLevelingSlopeArrowLineSymbol = new SimpleLineSymbol({
  color: 'black',
  width: 2,
  marker: {
    color: 'black',
    placement: 'end',
    style: 'arrow',
  },
});

export const __structureLineSymbol = new SimpleLineSymbol({
  style: 'solid',
  color: [0, 176, 240], //turquoise
  width: 2,
});

export const __ugoLineSymbol = new SimpleLineSymbol({
  style: 'solid',
  color: [0, 176, 240], //turquoise
  width: 2,
});

export const __wwWaterLevelLineSymbol = new SimpleLineSymbol({
  style: 'solid',
  color: 'blue',
  width: 1,
});

export const __wwConnectedLineSymbol = new SimpleLineSymbol({
  style: 'dash-dot',
  color: __wwConnectedLineColor,
  width: 2,
});
export const __wwBreaklinesSymbol = new SimpleLineSymbol({
  style: 'dot',
  color: __wwBreaklinesSymbolColor,
  width: 3,
  cap: 'square'
});
export const __channelBottomSymbol = new SimpleLineSymbol({
  color: 'blue',
  width: 3,
  style: 'short-dash-dot',
});

export const __wwCenterLineSymbol = new SimpleLineSymbol({
  style: 'short-dot',
  color: __wwOffMagentaColor,
  width: 4,
});

export const __landLevelingFillSymbol = new SimpleFillSymbol({
  color: [227, 139, 79, 0.8],
});

export const __moveRotateSymbol = new SimpleFillSymbol({
  style: 'solid',
  color: 'transparent',
  outline: { color: 'orange', width: 3 },
});

export const __trcBottomPolygonSymbol = new SimpleFillSymbol({
  style: 'solid',
  color: 'transparent',
  outline: {
    color: __trcChannelBottomColor,
    width: 2,
    style: 'short-dash-dot'
  }
});

export const __trcSubbasinPolygonSymbol = new SimpleFillSymbol({
  style: 'solid',
  color: 'transparent',
  outline: { color: 'white', width: 3 },
});

export const __trcSlopePolygonSymbol = new SimpleFillSymbol({
  style: 'solid',
  color: __trcSlopeFillColor,
  outline: { color: __trcSlopeBorderColor, width: 3 },
});

export const __trcCutSlopePolygonSymbol = new SimpleFillSymbol({
  style: 'solid',
  color: 'transparent',
  outline: { color: __trcSlopeBorderColor, width: 3 },
});

export const __trcRidgeTopPolygonSymbol = new SimpleFillSymbol({
  style: 'solid',
  color: __trcRidgeTopFillColor,
  outline: { color: 'black', width: 3 },
});

export const __trcBorderPolygonSymbol = new SimpleFillSymbol({
  style: 'solid',
  color: 'transparent',
  outline: { color: __wwOffMagentaColor, width: 4.5 },
});

export const __wwBorderPolygonSymbol = new SimpleFillSymbol({
  style: 'solid',
  color: 'transparent',
  outline: { color: __wwOffMagentaColor, width: 3 },
});

export const __wwCrossPolygonSymbol = new SimpleFillSymbol({
  style: 'solid',
  color: __wwCrossPolygonColor,
  outline: {
    style: 'dash',
    color: 'black', // __wwCrossPolygonOutColor,
    width: 1.5,
  },
});

export const __trcCrossLineSymbol = new SimpleLineSymbol({
  style: 'dash',
  color: 'black',
  width: 2,
});

export const __wwLevelPolygonSymbol = new SimpleFillSymbol({
  style: 'solid',
  color: __wwLevelColor,
  outline: {
    style: 'solid',
    color: __wwLevelOutColor,
    width: 5,
  },
});

export const __wwSeedingPolygonSymbol = new SimpleFillSymbol({
  style: 'solid',
  color: __wwSeedingPolygonColor,
  outline: {
    color: 'transparent',
  },
});

export const __wwSeedingOutlineSymbol = new SimpleLineSymbol({
  style: 'dash',
  color: 'black',
  width: 3,
});

export const __landLevelingPlanePointsUnmodified = new SimpleMarkerSymbol({
  color: [0, 0, 0, 1.0],
  size: 6,
  style: 'circle',
  outline: {
    style: 'solid',
    color: [0, 0, 0],
    width: 1,
  },
});

export const __landLevelingPlanePointsFill = new SimpleMarkerSymbol({
  color: [0, 128, 0, 1.0],
  size: 6,
  style: 'circle',
  outline: {
    style: 'solid',
    color: [0, 0, 0],
    width: 1,
  },
});

export const __landLevelingPlanePointsCut = new SimpleMarkerSymbol({
  color: [255, 0, 0, 1.0],
  size: 6,
  style: 'circle',
  outline: {
    style: 'solid',
    color: [0, 0, 0],
    width: 1,
  },
});

export const __landLevelingStakeoutGridPointsSymbol = new SimpleMarkerSymbol({
  color: 'blue',
  size: 7,
  style: 'cross',
  outline: {
    style: 'solid',
    color: 'blue',
    width: 1,
  },
});

export const __standardLabelSymbol = {
  color: 'black',
  font: { // autocast as esri/symbols/Font
    size: 11,
    family: 'sans-serif'
  },
  haloColor: [246, 246, 246, 1.0],
  haloSize: 1,
};

export const __lineLabelSymbol = new TextSymbol({
  color: 'black',
  font: { // autocast as esri/symbols/Font
    size: 11,
    family: 'sans-serif'
  },
  haloColor: [246, 246, 246, 1.0],
  haloSize: 1,
});
